import { BaseModel } from './BaseModel';

export class ServerVariable extends BaseModel {
    public name = '';
    public description = '';
    public descriptionIsMarkdown = false;
    public envVariable = '';
    public userEditable = false;
    public rules = '';
    public tickable = false;
    public serverValue = '';
    public defaultValue = '';
    public defaultValueRandom = false;
}
